import React from 'react'


const GlobalsContext = React.createContext({}) // TODO @frontends where to put this?


export default GlobalsContext
